<template>
    <router-link
        tag="li"
        class="block border-b border-gray-200 bg-white transition-colors hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-750"
        :to="{
            name: 'audit.interactions',
            params: {
                audit_id: audit.id,
            },
        }"
    >
        <div class="flex items-center px-4 py-4">
            <div class="flex min-w-0 flex-1 items-center">
                <div class="shrink-0">
                    <dice-bear-avatar
                        :url="audit.user.avatar"
                        :seed="audit.email"
                    />
                </div>
                <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-4 md:gap-4">
                    <div>
                        <p class="truncate text-sm font-medium text-gray-900 dark:text-white">
                            {{ audit.name }}
                        </p>
                        <p class="mt-1 flex items-center text-xs text-gray-500">
                            <EnvelopeIcon
                                class="mr-1.5 h-3.5 w-3.5 shrink-0 text-gray-400"
                                aria-hidden="true"
                            />
                            <span class="truncate">{{ audit.email }}</span>
                        </p>
                    </div>
                </div>
                <div class="ml-auto hidden items-end space-y-2 md:flex md:flex-col">
                    <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                        <ClockIcon class="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
                        <time :datetime="audit.created_at">{{ audit.created_at }}</time>
                        <span
                            v-if="audit.due_days_left"
                            class="rounded-md bg-indigo-50 px-1.5 py-0.5 font-mono text-[10px] text-indigo-600 ring-1 ring-inset ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-400 dark:ring-indigo-500/20"
                            v-tooltip="'Vencimento: ' + audit.due_date"
                        >
                            {{ audit.due_days_left }}d
                        </span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span
                            v-if="audit.stage"
                            class="inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset"
                            :class="stagePillClass(audit.stage)"
                        >
                            <span class="h-1 w-1 rounded-full" :class="stageDotClass(audit.stage)"></span>
                            {{ stageName(audit.stage) }}
                        </span>
                        <audit-status :audit="audit" />
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import {
    CheckCircleIcon,
    ChevronDownIcon,
    ClockIcon,
    EnvelopeIcon,
    NoSymbolIcon,
    ExclamationCircleIcon,
} from "@heroicons/vue/24/outline";
import AuditStatus from "./AuditStatus.vue";
import DiceBearAvatar from "../common/DiceBearAvatar.vue";

export default {
    components: {
        DiceBearAvatar,
        AuditStatus,
        ExclamationCircleIcon,
        ClockIcon,
        CheckCircleIcon,
        NoSymbolIcon,
        ChevronDownIcon,
        EnvelopeIcon,
    },
    props: ["audit"],

    methods: {
        stageName(stage) {
            const map = {
                under_review: "Em Análise",
                under_appeal: "Em Contestação",
                approved: "Aprovado",
                temporary_block: "Bloq. Temporário",
                permanent_block: "Bloq. Permanente",
            };

            return map[stage] || stage;
        },
        stagePillClass(stage) {
            const map = {
                under_review: "bg-amber-100 text-amber-700 ring-amber-300 dark:bg-amber-500/10 dark:text-amber-400 dark:ring-amber-500/20",
                under_appeal: "bg-orange-100 text-orange-700 ring-orange-300 dark:bg-orange-500/10 dark:text-orange-400 dark:ring-orange-500/20",
                approved: "bg-emerald-100 text-emerald-700 ring-emerald-300 dark:bg-emerald-500/10 dark:text-emerald-400 dark:ring-emerald-500/20",
                temporary_block: "bg-red-100 text-red-700 ring-red-300 dark:bg-red-500/10 dark:text-red-400 dark:ring-red-500/20",
                permanent_block: "bg-red-100 text-red-800 ring-red-400 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/30",
            };

            return map[stage] || "bg-gray-100 text-gray-600 ring-gray-300 dark:bg-gray-600/30 dark:text-gray-400 dark:ring-gray-600";
        },
        stageDotClass(stage) {
            const map = {
                under_review: "bg-amber-500 dark:bg-amber-400",
                under_appeal: "bg-orange-500 dark:bg-orange-400",
                approved: "bg-emerald-500 dark:bg-emerald-400",
                temporary_block: "bg-red-500 dark:bg-red-400",
                permanent_block: "bg-red-600 dark:bg-red-300",
            };

            return map[stage] || "bg-gray-400 dark:bg-gray-500";
        },
    },

    data() {
        return {
            menu: [
                { label: "Usuários", modal: "users" },
                { label: "Alterar", modal: "update" },
                { label: "Remover", modal: "destroy" },
            ],
            modals: {
                users: false,
                update: false,
                destroy: false,
            },
        };
    },
};
</script>
